export default __webpack_public_path__ + "static/media/uu_dai.a3e21fe0.png";